/* eslint-disable no-empty-function */

import { Method } from 'axios';

/**
 * Abstract class that defines the required functions to properly invoke a BambuMeta request from a client application.
 */
export abstract class Executable<T> {
  public async prepareRequest(options: {
    execute: (executable: Executable<any>) => Promise<any>;
  }): Promise<any> {}

  /**
   * This function returns any body object that would be passed to the API request.
   */
  abstract getBody(): any;

  /**
   * The URL path to invoke.
   * @param tenantId The tenantId provided by the BambuMeta client.
   */
  // eslint-disable-next-line no-unused-vars
  abstract getURLPath(tenantId?: string): string;

  /**
   * The rest function method to invoke the api with.
   */
  abstract getMethod(): Method;

  /**
   * This returns the proper response type for the execute function.
   * @param apiResponse The response from the API request.
   */
  // eslint-disable-next-line no-unused-vars
  abstract getResponse(apiResponse: any): T;

  /**
   * This function overloads the default rootPath for the API request.
   */
  abstract getRootPath(): string | undefined;
}

export interface IPrepareRequestOptions {
  execute<T>(executable: Executable<T>): Promise<T>;
}
